import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { MotionConfig } from "framer-motion";
import { AuthProvider } from "./context/AuthContext";
import Layout from "./components/Layout";
import ScrollToTop from "./components/ScrollToTop";
import Home from "./pages/Home";
import Over from "./pages/Over";
import Diensten from "./pages/Diensten";
import Motoren from "./pages/Motoren";
import MotorDetail from "./pages/MotorDetail";
import Onderdelen from "./pages/Onderdelen";
import Contact from "./pages/Contact";
import Afspraak from "./pages/Afspraak";
import Santini from "./pages/Santini";
import SeoPage from "./pages/SeoPage";
import Beheer from "./pages/Beheer";
import QJMotor from "./pages/QJMotor";
import QJDetail from "./pages/QJDetail";
import QJCategorie from "./pages/QJCategorie";

function App() {
  return (
    <AuthProvider>
      <MotionConfig reducedMotion="user">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Layout><Home /></Layout>} />
          <Route path="/over" element={<Layout><Over /></Layout>} />
          <Route path="/diensten" element={<Layout><Diensten /></Layout>} />
          <Route path="/motoren" element={<Layout><Motoren /></Layout>} />
          <Route path="/motoren/:id" element={<Layout><MotorDetail /></Layout>} />
          <Route path="/onderdelen" element={<Layout><Onderdelen /></Layout>} />
          <Route path="/contact" element={<Layout><Contact /></Layout>} />
          <Route path="/afspraak" element={<Layout><Afspraak /></Layout>} />
          <Route path="/santini" element={<Layout><Santini /></Layout>} />
          <Route path="/qj-motor" element={<Layout><QJMotor /></Layout>} />
          <Route path="/qj-motor/categorie/:slug" element={<Layout><QJCategorie /></Layout>} />
          <Route path="/qj-motor/:id" element={<Layout><QJDetail /></Layout>} />
          <Route path="/beheer" element={<Beheer />} />
          <Route path="/:slug" element={<Layout><SeoPage /></Layout>} />
        </Routes>
      </BrowserRouter>
      </MotionConfig>
    </AuthProvider>
  );
}

export default App;
